import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FadeIn } from './ui/FadeIn';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Cuándo veré los primeros resultados reales?',
    a: 'En las primeras 48 horas notarás cambios iniciales, y en una semana el patrón de sueño mejora notablemente.'
  }, {
    q: '¿Necesito equipo especial?',
    a: 'No, solo necesitas la guía, un ambiente adecuado y seguir las micro-pausas.'
  }, {
    q: '¿Y si mi bebé es muy inquieto por las noches?',
    a: 'El método se adapta incluso a bebés muy inquietos, ajustando las pausas según la edad.'
  }, {
    q: '¿Funciona con bebés más grandes?',
    a: 'Está diseñado para bebés de 0 a 12 meses, y hay tablas de ajuste para cada rango de edad.'
  }, {
    q: '¿Qué hago si no veo mejoras en 48 horas?',
    a: 'Revisa los ajustes por edad y entorno, y ajusta las micro-pausas según las recomendaciones.'
  }];
  return <section className="py-24" data-id="element-127">
      <div className="max-w-3xl mx-auto px-6" data-id="element-128">
        <FadeIn data-id="element-129">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-brown-dark mb-12" data-id="element-130">
            Preguntas Frecuentes
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-131">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.1} direction="up" data-id="element-132">
              <div className={`bg-white rounded-2xl border transition-colors duration-300 overflow-hidden ${openIndex === index ? 'border-accent shadow-sm' : 'border-cream-dark hover:border-accent/50'}`} data-id="element-133">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" aria-expanded={openIndex === index} data-id="element-134">
                  <span className="font-serif font-bold text-lg text-brown-dark pr-8" data-id="element-135">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-accent flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-136" />
                </button>

                <AnimatePresence data-id="element-137">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-138">
                      <div className="px-6 pb-5 text-brown-dark/80 leading-relaxed" data-id="element-139">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}